/* Little Premiere — landing. Aucun script tiers : les événements partent par les customer events de Shopify
   (même préfixe « lp: » que le tunnel, pour qu'un seul pixel personnalisé les reprenne tous). */
(function () {
  'use strict';
  var params = new URLSearchParams(location.search);
  var angle = params.get('a');
  if (angle !== 'parent' && angle !== 'grandparent') angle = null;
  var urlAdv = (params.get('adv') || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 32) || null;
  // fbclid (20/10) : Meta l'ajoute à l'URL de la pub ; sans lui, le clic ne se rattache pas à la commande dans le tunnel.
  var PASS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'adset', 'fbclid'];

  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lp:' + name, data || {}); } catch (e) { /* pixel absent */ }
  }
  // Date du jour à New York : les commandes ferment à 23:59 heure de New York (même règle que le tunnel).
  function today() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { var d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  }

  // 1. Dates limites : la page peut venir du cache de Shopify, on revérifie côté navigateur.
  var t = today();
  // Une date seule (AAAA-MM-JJ) ferme à minuit, heure de New York ; une date-heure ISO ferme à l'instant exact
  // (Halloween : 2026-10-30T12:00:00-04:00, même valeur que orders_until dans le catalogue du tunnel).
  function past(v) {
    if (!v) return false;
    if (v.indexOf('T') > 0) { var ms = Date.parse(v); return !isNaN(ms) && Date.now() >= ms; }
    return t > v;
  }
  document.querySelectorAll('[data-hide-after]').forEach(function (el) {
    if (past(el.getAttribute('data-hide-after'))) el.remove();
  });
  // Vignette qui passe « en grand » quand une autre ferme (Dino à la fermeture d'Halloween), même règle de date.
  document.querySelectorAll('[data-feature-after]').forEach(function (el) {
    if (past(el.getAttribute('data-feature-after'))) el.classList.add('lpl-card--feature');
  });
  var closed = {};
  document.querySelectorAll('[data-close-after]').forEach(function (sec) {
    if (!past(sec.getAttribute('data-close-after'))) return;
    sec.querySelectorAll('[data-lpl-open-only]').forEach(function (el) { el.remove(); });
    closed[sec.getAttribute('data-adv')] = sec.getAttribute('data-fallback-adv') || null;
  });
  // Aventure « bientôt » (Pirate, Jungle : pas encore de film-modèle) : visible, mais ses boutons mènent à data-soon-adv.
  document.querySelectorAll('[data-soon-adv]').forEach(function (sec) {
    closed[sec.getAttribute('data-adv')] = sec.getAttribute('data-soon-adv') || null;
  });

  // 2. Liens vers le tunnel : l'aventure de la pub (?adv=) l'emporte sur les boutons génériques, l'angle (?a=) et les
  //    utm_* suivent jusqu'au tunnel, qui les journalise par ensemble de pubs.
  document.querySelectorAll('a[data-lpl-cta]').forEach(function (a) {
    var u = new URL(a.getAttribute('href'), location.origin);
    if (urlAdv && a.hasAttribute('data-generic') && !(urlAdv in closed)) u.searchParams.set('adv', urlAdv);
    var cur = u.searchParams.get('adv');
    if (cur in closed) { if (closed[cur]) u.searchParams.set('adv', closed[cur]); else u.searchParams.delete('adv'); }
    if (angle && !a.hasAttribute('data-angle')) u.searchParams.set('a', angle);
    PASS.forEach(function (k) { var v = params.get(k); if (v && !u.searchParams.has(k)) u.searchParams.set(k, v); });
    a.setAttribute('href', u.pathname + u.search);
    a.addEventListener('click', function () {
      publish('landing_cta', { position: a.getAttribute('data-pos'), adventure: u.searchParams.get('adv'), angle: u.searchParams.get('a') });
    });
  });

  // 2 bis. Liens internes vers une autre page (accueil → page d'aventure) : utm_*, adset, fbclid et l'angle suivent aussi,
  //    sinon une pub qui pointe sur l'accueil perd son attribution dès que le parent ouvre une aventure (20/10).
  document.querySelectorAll('a[href^="/pages/"]:not([data-lpl-cta])').forEach(function (a) {
    var u = new URL(a.getAttribute('href'), location.origin);
    var n = 0;
    PASS.forEach(function (k) { var v = params.get(k); if (v && !u.searchParams.has(k)) { u.searchParams.set(k, v); n++; } });
    if (n && angle && !u.searchParams.has('a')) u.searchParams.set('a', angle);
    if (n) a.setAttribute('href', u.pathname + u.search + u.hash);
  });

  // 3. Texte grand-parent quand la pub l'annonce (?a=grandparent).
  if (angle === 'grandparent') {
    document.querySelectorAll('[data-lpl-gp-text]').forEach(function (el) {
      var v = el.getAttribute('data-lpl-gp-text'); if (v) el.textContent = v;
    });
  }

  // 4. Vidéos : chargées seulement au clic.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lpl-play]');
    if (!btn) return;
    var box = btn.closest('[data-lpl-video]');
    var src = box && box.getAttribute('data-src');
    if (!src) return;
    var v = document.createElement('video');
    v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute('playsinline', '');
    var img = box.querySelector('img, .lpl-video-ph');
    if (img) img.replaceWith(v); else box.prepend(v);
    box.classList.add('is-playing');
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    publish(box.getAttribute('data-kind') === 'film' ? 'film_play' : 'trailer_play', { adventure: box.getAttribute('data-adv') });
  });

  // 5. Avant / après.
  var slid = false;
  document.querySelectorAll('[data-lpl-ba]').forEach(function (ba) {
    var r = ba.querySelector('input[type=range]');
    if (!r) return;
    r.addEventListener('input', function () {
      ba.style.setProperty('--pos', r.value + '%');
      if (!slid) { slid = true; publish('ba_slide', {}); }
    });
  });

  // 6. Barre collante : visible quand le bouton du haut est sorti de l'écran, cachée sur le dernier appel.
  var sticky = document.querySelector('[data-lpl-sticky]');
  var top = document.querySelector('[data-lpl-hero-cta]');
  var fin = document.querySelector('[data-lpl-final]');
  if (sticky && top && 'IntersectionObserver' in window) {
    var topVisible = true, finVisible = false;
    var apply = function () {
      var on = !topVisible && !finVisible;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    new IntersectionObserver(function (en) { topVisible = en[0].isIntersecting; apply(); }).observe(top);
    if (fin) new IntersectionObserver(function (en) { finVisible = en[0].isIntersecting; apply(); }).observe(fin);
  }

  publish('landing_view', { page: location.pathname, adventure: urlAdv, angle: angle });

  // 5. Scènes en boucle (réactions) : on ne charge la vidéo que lorsqu'elle approche de l'écran.
  var scenes = document.querySelectorAll('video[data-lpl-scene]');
  if (scenes.length) {
    var start = function (v) { if (!v.src && v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); } var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(e.target); } else if (!e.target.paused) { e.target.pause(); } });
      }, { rootMargin: '200px 0px' });
      scenes.forEach(function (v) { io.observe(v); });
    } else { scenes.forEach(start); }
  }

  // 6. Boucle « dopamine » en tête : muette, lancée à l'écran ; le bouton son passe sur la bande-annonce complète.
  var narrow = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
  // Réactions : muettes en boucle ; le bouton son relance la scène depuis le début avec sa voix (une seule à la fois).
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lpl-react-sound]');
    if (!b) return;
    var v = b.parentNode.querySelector('video');
    if (!v) return;
    var on = v.muted;
    document.querySelectorAll('video[data-lpl-scene]').forEach(function (x) { if (x !== v) x.muted = true; });
    document.querySelectorAll('[data-lpl-react-sound]').forEach(function (x) { x.classList.remove('is-on'); x.textContent = '🔊'; });
    v.muted = !on;
    if (on) { v.currentTime = 0; b.classList.add('is-on'); b.textContent = '🔇'; publish('reaction_sound', {}); }
    var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; });
  });

  document.querySelectorAll('video[data-lpl-loop]').forEach(function (v) {
    var box = v.closest('[data-lpl-video]');
    var loopSrc = (narrow && v.getAttribute('data-loop-portrait')) || v.getAttribute('data-loop');
    if (narrow && v.getAttribute('data-loop-portrait') && box) box.classList.add('is-portrait');
    if (narrow && v.getAttribute('data-loop-portrait') && v.getAttribute('data-poster-portrait')) v.setAttribute('poster', v.getAttribute('data-poster-portrait'));
    var go = function () { if (!v.getAttribute('src')) v.src = loopSrc; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) go(); else if (!v.paused && v.muted) v.pause(); }); }, { rootMargin: '100px 0px' }).observe(v);
    } else go();
    var btn = box && box.querySelector('[data-lpl-sound]');
    var trailer = (narrow && v.getAttribute('data-trailer-portrait')) || v.getAttribute('data-trailer');
    if (!btn) return;
    if (!trailer) { btn.remove(); return; }
    btn.addEventListener('click', function () {
      v.src = trailer; v.loop = false; v.muted = false; v.controls = true;
      box.classList.add('is-playing');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      // Chrome met parfois en pause une vidéo lancée muette qu'on démute : on relance, toujours dans le geste.
      setTimeout(function () { if (v.paused && !v.ended) { var r = v.play(); if (r && r.catch) r.catch(function () {}); } }, 200);
      publish('trailer_play', { adventure: box.getAttribute('data-adv'), from: 'loop' });
      v.addEventListener('ended', function back() {
        v.removeEventListener('ended', back);
        v.controls = false; v.muted = true; v.loop = true; v.src = loopSrc; box.classList.remove('is-playing');
        var q = v.play(); if (q && q.catch) q.catch(function () {});
      });
    });
  });
})();

